<template>
    <main id="main" class="ms-sm-auto">
        <div class="container">

            <div class="breadcrumbs">
                <ul>
                    <li>
                        <a href="/connect-account-home">
                            <i class="lisa-icon-back"></i>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            {{$t("p_connect_account_btn")}}
                        </a>
                    </li>
                </ul>
            </div>
            <!--  -->
            <div class="modal modal-flex" id="formSuccessDuplicationModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 532px; max-width: 532px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLabel">Already connected</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="welcome-back">
                                <div class="welcome-back-content">
                                    You have connected to this student.<br>Please choose another account to connect.
                                </div>
                            </div>
                        </div>
                        <!-- <div class="modal-footer">
                            <a class="btn btn-main-border m-auto" style="padding: 8px 20px;" href="/">{{$t("finish")}}</a>
                        </div> -->
                    </div>
                </div>
            </div>

            <div class="modal modal-flex" id="formSuccessModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 532px; max-width: 532px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLabel">{{$t('p_connect_success')}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="welcome-back">
                                <img src="/themes/web/assets/images/modal-success.svg" alt="" />

                                <div class="welcome-back-content">
                                    {{ $t('lisa_web_see_report', {username: parent.username}) }}
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <a class="btn btn-main-border m-auto" style="padding: 8px 20px;" href="/">{{$t("finish")}}</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal modal-flex" id="formSuccessMail" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 456px; max-width: 456px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title">{{$t("success")}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="gotoGetChild(1)"></button>
                        </div>
                        <div class="modal-body">
                            <div class="welcome-back">
                                <img src="/themes/web/assets/images/success-1.svg" alt="" />

                                <div class="welcome-back-content">
                                    {{$t("lisa_web_we_hava_sent_a_key")}} <b>{{parent.username}}</b>.{{$t("lisa_web_check_mailbox")}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-modal" v-if="screen == 1">
                <div class="card-modal-title">{{$t("p_connect_account_btn")}}</div>

                <div class="card-modal-form">
                    <form action="">
                        <label class="card-modal-form-label">{{$t("p_child_username")}}</label>
                        <div>
                            <input type="text" class="form-control" :placeholder="$t('lisa_web_enter_username_child')" v-model="parent.username">
                        </div>
                        <label class="card-modal-form-label">{{$t("key_account")}}</label>
                        <div>
                            <input type="text" class="form-control" :placeholder="$t('lisa_web_enter_key')" v-model="parent.key">
                        </div>
                        <div>
                            <a class="card-modal-form-link" href="#" @click="gotoGetChild(2)">{{$t("p_dont_know_key")}}</a>
                        </div>
                        <div class="d-flex" style="justify-content: center; margin-top: 32px;">
                            <a style="display: block;margin-right: 60px;" href="/connect-account-home"> <button class="btn btn-main" disabled="" style="padding: 8px 30px;">{{$t("cancel")}}</button></a>
                            <!-- <button class="btn btn-main" disabled="" style="padding: 8px 30px;">{{$t("cancel")}}</button> -->
                            <button class="btn btn-main" style="padding: 8px 30px;" @click.prevent="getConnectChild">{{$t("next")}}</button>
                        </div>
                    </form>
                </div>
            </div>

            <div class="card-modal" v-if="screen == 2">
                <div class="card-modal-title">{{$t("p_mapping_title_02")}}</div>

                <div class="card-modal-form">
                    <form action="#">
                        <label class="card-modal-form-label">{{$t("p_child_username")}}</label>
                        <div>
                            <input type="text" class="form-control" placeholder="Enter your child’s username" autocomplete="off" v-model="parent.username">
                        </div>
                        <div>
                            <a class="card-modal-form-link"  @click="gotoGetChild(4)" href="#">{{$t("p_dont_know_username")}}</a>
                        </div>
                        <div class="d-flex" style="justify-content: center; margin-top: 32px;">
                            <a  href="/connect-account-home" style="display: block;" ><button class="btn btn-main" disabled="" style="padding: 8px 30px; margin-right: 60px;">{{$t("cancel")}}</button></a>
                            <!--<button class="btn btn-main" style="padding: 8px 30px;" data-bs-toggle="modal" data-bs-target="#formSuccess1Modal">Next</button>-->
                            <button class="btn btn-main" style="padding: 8px 30px;" :disabled="is_disable_child" @click.prevent="getChild">{{$t("next")}}</button>
                        </div>
                    </form>
                </div>
            </div>

            <div class="card-modal" v-if="screen == 3">
                <div class="card-modal-title">{{$t("p_mapping_title_05")}}</div>

                <div class="card-modal-form">
                    <form action="#">
                        <p><b>{{parent.fullname ? parent.fullname : parent.username}} ({{formatDate(parent.birthday)}})</b></p>
                        <p>{{$t("username")}}: <b>{{username}}</b></p>
                        <p>{{$t('email')}}: <b>{{hideEmail(parent.email)}}</b></p>
                        <p class="mb-20">{{$t('phone')}}: <b>{{hidePhone(parent.phone)}}</b></p>
                        <p>{{$t("p_mapping_child_text05")}}</p>
                        <div>
                            <div class="form-radio">
                                <input type="radio" id="your-email" name="your" value="0" checked="false" v-model="parent.type">
                                <label for="your-email">{{$t("email")}}</label>
                                <div class="form-radio-content">
                                    {{$t('email')}}: <span class="hightline">{{hideEmail(parent.email)}}</span>
                                </div>
                            </div>
                            <div class="form-radio">
                                <input type="radio" id="your-phone" name="your" value="1" v-model="parent.type">
                                <label for="your-phone">{{$t("phone")}}: </label>
                                <div class="form-radio-content">
                                    <p>{{$t("please_use_the_registered_phone_number_to_text_with_the_syntax")}}: <b>KeyAccount_{{parent.username}}</b> {{$t('and_send_to')}} <b>1900 9999</b> {{$t('lisa_web_to_get_key_account')}}.</p>
                                    <p>{{$t("note_the_fee_per_message_is")}} <b>7.000vnd</b></p>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="justify-content: center; margin-top: 32px;">
                            <a href="/connect-account-home" style="display: block"><button class="btn btn-main" disabled="" style="padding: 8px 30px; margin-right: 60px;">{{$t("cancel")}}</button></a>
                            <a class="btn btn-main" style="padding: 8px 30px;" @click.prevent="getKey">{{$t("next")}}</a>
                        </div>
                    </form>
                </div>
            </div>

            <div class="card-modal" v-if="screen == 4">
                <div class="card-modal-title">{{$t("p_mapping_title_02")}}</div>
                <div class="forgot-popup-content">
                    <label class="card-modal-form-label">{{$t("full_name")}} *</label>
                    <div>
                        <input type="text" class="form-control" placeholder="Nhập vào họ và tên của bạn" autocomplete="off" v-model="fullname">
                    </div>
                    <label class="card-modal-form-label">{{$t("date_of_birth")}} *</label>
                    <div style="position: relative;">
                        <input type="text" class="form-control lisa-input input-full-width date datepicker birthday" name="birthday" autocomplete="off" placeholder="dd/mm/yyyy" v-model="birthday">
                        <img class="icon-birthday" src="/themes/ito/images/icon-birthday.svg">
                    </div>
                </div>
                <!-- <div class="forgot-popup-footer">
                    <div class="form-group d-flex justify-content-center">
                        <a class="lisa-btn-small" href="/login">{{$t('cancel')}}</a>
                        <div class="lisa-btn-small" :class="(fullname != '' && birthday != '')?'lisa-btn-small active':'lisa-btn-small'"
                             @click="(fullname != '' && birthday != '')?getListChild():''">{{$t('next')}}</div>
                    </div>
                </div> -->
                <div class="d-flex" style="justify-content: center; margin-top: 32px;">
                    <a style="display: block;margin-right: 60px;" href="/connect-account-home"> <button class="btn btn-main" disabled="" style="padding: 8px 30px;">{{$t("cancel")}}</button></a>
                    <button class="btn btn-main" style="padding: 8px 30px;" @click="(fullname != '' && birthday != '')?getListChild():''">{{$t("next")}}</button>
                </div>
            </div>

            <div class="card-modal" v-if="screen == 5">
                <div class="card-modal-title">{{$t("p_mapping_title_05")}}</div>
                <div class="card-modal-form">
                    <form action="#">
                        <p>{{ $t('lisa_web_system_find') }} <b>{{ list_accounts.length }}</b> {{ $t('student') }}:</p>
                        <div class="card-modal-items" style="max-height: 245px; height: 245px;">
                            <div class="" tabindex="0" style="right: -17px;">
                                <div style="cursor: pointer;" :class="`card-modal-item account-${index}`" v-for="(account,index) in list_accounts" @click="e => chooseAccount(index, e)">
                                    <p><b>{{ account.fullname }} ({{account.birthday}})</b></p>
                                    <p>{{ $t('username') }}: <b>{{hideEmail(account.email)}}</b></p>
                                    <p>{{ $t('phone') }}: <b>{{hidePhone(account.phone)}}</b></p>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="justify-content: center; margin-top: 32px;">
                            <button class="btn btn-main" style="background: linear-gradient(180deg, #CBCBCB 0%, #B3B3B3 100%);padding: 8px 30px; margin-right: 60px;" @click="gotoGetChild(1)">{{ $t('cancel') }}</button>
                            <button class="btn btn-main" @click.prevent="nextAccount()" style="padding: 8px 30px;">{{ $t('next') }}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </main>

</template>

<script>
    import axios from "axios";
    import {pushQueries, soundClick, toPercent} from '../../utils/utils'
    import {showDialog} from '../../utils/dialog'
    import {mapGetters} from 'vuex'
    import {getParentReport, getChildAccount, getListChildAccount, getKeyAccount, sendConnect } from "../../models/parent";

    export default {
        name: "ParentConnect",
        title: 'Parents - Connect',

        data() {
            return {
                username: '',
                account: '',
                list_accounts: [],
                birthday: '',
                fullname: '',
                screen: 1,
                parent: {
                    username: '',
                    birthday: '',
                    email: '',
                    fullname: '',
                    id: '',
                    phone: '',
                    key: '',
                    type: '',
                },
                is_disable_child: true,
            };
        },

        created() {
            // this.$store.commit('setMenuActive', 'parent');
            this.fetch();
        },

        watch: {
            'parent.username': function (newVal, oldVal) {
                newVal !== '' ? this.is_disable_child = false : this.is_disable_child = true;
            },
        },

        methods: {
            formatDate(input, format = 'DD MMM, YYYY HH:mm:ss'){
                var datePart = input.match(/\d+/g),
                year = datePart[0].substring(0), // get only two digits
                month = datePart[1], day = datePart[2];

                return day+'/'+month+'/'+year;
            },
            hideEmail(email) {
                if (email == '') {
                    return ''
                }
                let hide = email.split("@")[1].length - 5;
                let r = new RegExp(".{" + hide + "}@", "g");
                return email.replace(r, "****@");
            },
            hidePhone(phone){
                if(phone == ''){
                    return ''
                }
                return phone.replace(/(\d{2})(.*)(\d{3})/, '$1*****$3')
            },
            fetch(page = 1) {

            },
            gotoGetChild(screen){
                this.parent.username = '';
                this.parent.key = '';
                this.screen = screen;

                this.$nextTick(function () {
                    $('.birthday').datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showOtherMonths: true,
                        selectOtherMonths: false,
                        yearRange: '1900:+0',
                        monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
                    }).on('change', (e) => {
                        this.searchDate(e);
                    });
                })
            },
            getConnectChild() {
                const that = this;
                that.$store.commit("setLoading", true);
                const formData = new FormData();
                formData.append('username', this.parent.username);
                formData.append('key', this.parent.key);
                sendConnect(formData).then((data) => {
                    that.$store.commit("setLoading", false);
                    if (data.data.code == 0) {
                        $('#formSuccessModal').modal('show');
                    }
                    else{
                        if (data.data.error_code == "error_connected") {
                            $('#formSuccessDuplicationModal').modal('show');
                        }else{
                            showDialog('error', 'Error', data.data.results);
                        }
                    }
                }).catch(({response}) => {
                    that.$store.commit("setLoading", false);
                    showDialog('error', 'Error', response.data.results);
                });
            },
            getChild() {
                const that = this;
                const formData = new FormData();
                formData.append('username', this.parent.username);
                getChildAccount(formData).then((data) => {
                    that.$store.commit("setLoading", false);
                    if (data.data.code == 0) {
                        that.parent.birthday = data.data.results.birthday;
                        that.parent.email = data.data.results.email;
                        that.parent.fullname = data.data.results.fullname;
                        that.parent.id = data.data.results.id;
                        that.parent.username = data.data.results.username;
                        that.parent.phone = data.data.results.phone;
                        that.screen = 3;
                    }
                    else{
                        showDialog('error', 'Error', data.data.results);
                    }
                }).catch(({response}) => {
                    that.$store.commit("setLoading", false);
                    showDialog('error', 'Error', response.data.results);
                });
            },
            searchDate({target}){
                this.birthday = target.value;
            },
            chooseAccount(index, event){
               this.account = index
               $('.card-modal-item').css({'background':'#fff', 'color':'#000'})
               $(`.card-modal-item.account-${index}`).css({'background':'#FD970C', 'color':'#fff'})
               console.log(this.list_accounts);
            },
            nextAccount(){
                this.parent.email =  this.list_accounts[this.account].email;
                this.username = this.list_accounts[this.account].username;
                this.parent.phone = this.list_accounts[this.account].phone;
                this.parent.fullname = this.list_accounts[this.account].fullname;
                this.parent.birthday = this.list_accounts[this.account].birthday;
                this.gotoGetChild(3)
            },
            getListChild() {
                const that = this;
                const formData = new FormData();
                formData.append('fullname', this.fullname);
                formData.append('birthday', moment(that.birthday, 'DD/MM/YYYY').format('YYYY/MM/DD'));
                getListChildAccount(formData).then((data) => {
                    that.$store.commit("setLoading", false);
                    if (data.data.code == 0) {
                        console.log( data.data.results);
                        that.list_accounts = data.data.results || [];
                        that.gotoGetChild(5)
                    }
                    else{
                        showDialog('error', 'Error', data.data.results);
                    }
                }).catch(({response}) => {
                    that.$store.commit("setLoading", false);
                    showDialog('error', 'Error', response.data.results);
                });
            },

            getKey(){
                const that = this;
                const formData = new FormData();
                formData.append('username', this.username);
                formData.append('type', this.parent.type);
                formData.append('email', this.parent.email);
                formData.append('phone', this.parent.phone);
                console.log(this.parent.username, this.parent.type, this.parent.email, this.parent.phone);
                getKeyAccount(formData).then((data) => {
                    that.$store.commit("setLoading", false);
                    if (data.data.code == 0) {
                        $('#formSuccessMail').modal('show');
                    }
                    else{
                        showDialog('error', 'Error', data.data.results);
                    }
                }).catch(({response}) => {
                    that.$store.commit("setLoading", false);
                    showDialog('error', 'Error', response.data.results);
                });
            },

            getSoundClick() {
                soundClick();
            },

        }
    }
</script>

<style scoped>
    .card-modal-items{
        overflow-y: auto;
    }
    .btn-main-border{
        background: linear-gradient(180deg, #45BCFF 0%, #00A3FF 100%);
        box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07), inset 0px 2px 0px rgba(255, 255, 255, 0.2);
        border-radius: 8px;
        width: 158px;
        height: 36px;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .icon-birthday{
        position: absolute;
        width: 20px;
        top: 10px;
        right: 15px;
        z-index: 0;
    }
</style>
